import { TRANSACTIONS, MAX_DELEGATIONS, MAX_TEXT, emptyCriteria } from "./propertyRequestForm";

// Draft of "Je recherche un bien", kept for the browser tab while the visitor signs in.
// Only the text, the criteria, their sources, unscored codes and the step are stored: never e-mail, phone, token or UID.
export const DRAFT_KEY = "lina.propertyRequestDraft.v1";
const STEPS = ["edit", "preview"];
const UNSCORED = ["parking", "furnished", "kitchen", "ac", "pool", "garden", "barbecue", "beachAccess", "workspace", "washer", "wifi", "tv", "elevator", "balcony", "seaView"];
const FIELDS = ["budgetMin", "budgetMax", "surfaceMin", "surfaceMax", "bedroomsMin"];
// Contact details typed in the free text are masked before the draft is written.
const CONTACT = /https?:\/\/\S+|\bwww\.\S+|\S+@\S+|(?:\+?\d[\s().-]*){8,}/gi;

const strings = (value, max) =>
  Array.isArray(value) ? [...new Set(value.filter((v) => typeof v === "string" && v.length <= 120))].slice(0, max) : [];

export function sanitizeDraft(value) {
  if (!value || typeof value !== "object") return null;
  const source = value.criteria && typeof value.criteria === "object" ? value.criteria : {};
  const criteria = emptyCriteria();
  criteria.transaction = TRANSACTIONS.includes(source.transaction) ? source.transaction : "";
  criteria.categories = strings(source.categories, 5);
  criteria.city = typeof source.city === "string" && source.city.length <= 120 ? source.city : "";
  criteria.delegations = strings(source.delegations, MAX_DELEGATIONS);
  criteria.attributes = strings(source.attributes, 10);
  for (const field of FIELDS)
    criteria[field] = typeof source[field] === "string" || typeof source[field] === "number" ? String(source[field]).slice(0, 20) : "";
  const text = typeof value.text === "string" ? value.text.slice(0, MAX_TEXT).replace(CONTACT, (m) => (/\s$/.test(m) ? "[…] " : "[…]")) : "";
  const sources = {};
  if (value.sources && typeof value.sources === "object")
    for (const [key, origin] of Object.entries(value.sources))
      if ((key in criteria) && (origin === "manual" || origin === "ai" || origin === "auto")) sources[key] = origin;
  const unscored = Array.isArray(value.unscored) ? [...new Set(value.unscored.filter((u) => UNSCORED.includes(u)))] : [];
  return { version: 1, text, criteria, sources, unscored, step: STEPS.includes(value.step) ? value.step : "edit" };
}

export const isMeaningful = (draft) =>
  Boolean(draft && (draft.text.trim() || draft.criteria.transaction || draft.criteria.categories.length || draft.criteria.city));

export function saveDraft(draft) {
  const clean = sanitizeDraft(draft);
  try {
    if (isMeaningful(clean)) window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify(clean));
    else window.sessionStorage.removeItem(DRAFT_KEY);
  } catch { /* Storage may be unavailable (private mode, blocked site data). */ }
}

export function loadDraft() {
  try {
    const raw = window.sessionStorage.getItem(DRAFT_KEY);
    const draft = raw ? sanitizeDraft(JSON.parse(raw)) : null;
    return isMeaningful(draft) ? draft : null;
  } catch {
    return null;
  }
}

export function clearDraft() {
  try { window.sessionStorage.removeItem(DRAFT_KEY); } catch { /* Storage may be unavailable. */ }
}

export const hasDraft = () => loadDraft() != null;
